import { Link } from "react-router-dom";
import { useLang, useL } from "@/lib/i18n";
import { useSite } from "@/lib/site";
import { LEGAL, RULE_SECTIONS } from "@/lib/legal";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";

function Section({ title, items }) {
  return (
    <section className="mb-8">
      <h2 className="mb-3 font-display text-2xl uppercase text-white">{title}</h2>
      <ul className="list-disc space-y-2 pl-5 text-sm text-slate-300 md:text-base">{items.map((x, i) => <li key={i}>{x}</li>)}</ul>
    </section>
  );
}

export default function Legal({ kind }) {
  const { lang } = useLang();
  const L = useL();
  const { site } = useSite();
  const d = LEGAL[lang];
  const sections = kind === "terms" ? d.terms : kind === "rules" ? RULE_SECTIONS.map((i) => d.terms[i]) : d.privacy;
  const title = { terms: L("Conditions générales", "Terms and Conditions"), rules: L("Règlement du studio", "Studio Rules"), privacy: L("Avis de confidentialité", "Privacy Notice") }[kind];
  const cam = site?.privacy?.[`camera_${lang}`];
  return (
    <div className="min-h-screen bg-[#08080a]" data-testid={`legal-${kind}`}>
      <Navbar home={false} />
      <main className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
        <h1 className="font-display text-5xl uppercase text-white">{title}</h1>
        <p className="mb-8 mt-2 font-mono text-xs text-slate-500">Version {site?.terms_version} · {L("Document généré, non approuvé juridiquement.", "Generated document, not legally approved.")}</p>
        {sections.map(([t, items]) => <Section key={t} title={t} items={items} />)}
        {kind === "privacy" && (
          <Section title={L("Caméras de sécurité", "Security cameras")} items={[cam || L("Les informations sur les caméras (emplacements, objectif, captation audio, durée de conservation) seront publiées par le studio.", "Camera details (locations, purpose, audio capture, retention period) will be published by the studio."), `${L("Questions de confidentialité", "Privacy questions")} : ${site?.privacy?.contact || ""}`]} />
        )}
        <div className="flex flex-wrap gap-4 text-sm">
          <Link to="/terms" className="text-red-400" data-testid="legal-link-terms">{L("Conditions", "Terms")}</Link>
          <Link to="/rules" className="text-red-400" data-testid="legal-link-rules">{L("Règlement", "Rules")}</Link>
          <Link to="/privacy" className="text-red-400" data-testid="legal-link-privacy">{L("Confidentialité", "Privacy")}</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
